"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FirstTimeUserExperienceType = void 0;
var FirstTimeUserExperienceType;
(function (FirstTimeUserExperienceType) {
    FirstTimeUserExperienceType["viewInstantBtDuringOnboarding"] = "viewInstantBtDuringOnboarding";
    FirstTimeUserExperienceType["viewAvenHomeCardUpgradeInterstitial"] = "viewAvenHomeCardUpgradeInterstitial";
    FirstTimeUserExperienceType["viewAvenHomeCardUpgradeNotTakenSurvey"] = "viewAvenHomeCardUpgradeNotTakenSurvey";
    FirstTimeUserExperienceType["viewUccWelcomeUpsells"] = "viewUccWelcomeUpsells";
    FirstTimeUserExperienceType["viewBalanceTransferSavingsGuaranteePostActivation"] = "viewBalanceTransferSavingsGuaranteePostActivation";
    FirstTimeUserExperienceType["viewCryptoWelcome"] = "viewCryptoWelcome";
    FirstTimeUserExperienceType["dismissCardArrivalCheck"] = "dismissCardArrivalCheck";
    FirstTimeUserExperienceType["dismissAddToWalletBanner"] = "dismissAddToWalletBanner";
    FirstTimeUserExperienceType["viewRewardsBtUpsellPostActivation"] = "viewRewardsBtUpsellPostActivation";
    FirstTimeUserExperienceType["viewRewardsDepositBundleUpsellPostActivation"] = "viewRewardsDepositBundleUpsellPostActivation";
})(FirstTimeUserExperienceType || (exports.FirstTimeUserExperienceType = FirstTimeUserExperienceType = {}));
